export default __webpack_public_path__ + "static/media/icon_ui_mapsettings.8f5be39e.png";